import { ClinicDto } from '@dentitek-cloud/shared/dtos/clinic/clinicDto'

import { Clinic } from '@/app/models/Clinic'

export const toClinic = (dto: ClinicDto): Clinic => ({
  id: dto.id,
  name: dto.name,
  timezone: dto.timezone,
})
